import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WindowHeightService implements OnDestroy {
  height$: Observable<number>;

  private windowHeight = window.innerHeight;
  private lastWindowHeight = 0;
  private timerId: NodeJS.Timer;
  private readonly heightSource$ = new BehaviorSubject(0);

  constructor() {
    this.height$ = this.heightSource$.asObservable();
  }

  init(): void {
    if (this.timerId !== undefined) {
      return;
    }

    const INTERVAL = 500;
    this.timerId = setInterval(() => {
      this.windowHeight = window.innerHeight;
      if (this.lastWindowHeight !== this.windowHeight) {
        this.lastWindowHeight = this.windowHeight;
        this.heightSource$.next(this.windowHeight);
      }
    }, INTERVAL);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerId);
  }
}
